import { useQuery } from '@tanstack/react-query'
import { liveCheckinLevelsRewardsService } from '../../services/lives-checkins-levels-rewards'

export const LEVELS_REWARDS_KEY = 'getLiveCheckinLevelsRewards'

export function useGetLevelsRewards() {
  const { data, isLoading } = useQuery({
    queryKey: [LEVELS_REWARDS_KEY],
    queryFn: () =>
      liveCheckinLevelsRewardsService.getList({
        take: 200,
        active: true,
        deleted: false,
      }),
  })

  return {
    rewards: data?.data ?? [],
    isLoading,
  }
}
